import { BusinessGooglePlace } from "../../../interfaces/BusinessObject";
import { getGoogleMapsUrl } from "../../helpers/BusinessLocationHelper";

function attributionUrl(value: unknown): string | null {
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) && !url.username && !url.password ? url.href : null;
  } catch {
    return null;
  }
}

export function convertBusinessGooglePlace(value: unknown, expectedPlaceId: string): BusinessGooglePlace | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const raw = value as Record<string, unknown>;
  // A business can be relinked while this request is in flight.
  if (raw.placeId !== expectedPlaceId) return null;
  return {
    placeId: expectedPlaceId,
    rating: typeof raw.rating === "number" && Number.isFinite(raw.rating) && raw.rating >= 1 && raw.rating <= 5 ? raw.rating : null,
    userRatingCount: typeof raw.userRatingCount === "number" && Number.isSafeInteger(raw.userRatingCount) && raw.userRatingCount >= 0 ? raw.userRatingCount : null,
    googleMapsUri: getGoogleMapsUrl(raw.googleMapsUri),
    attributions: Array.isArray(raw.attributions) ? raw.attributions.flatMap((item: unknown) => {
      if (!item || typeof item !== "object") return [];
      const { provider, providerUri } = item as Record<string, unknown>;
      return typeof provider === "string" && provider.trim()
        ? [{ provider: provider.trim(), providerUri: attributionUrl(providerUri) }]
        : [];
    }) : [],
  };
}
